import * as React from "react";
import {RouteComponentProps} from "react-router";
import {AppNotificationMessage, AppNotificationType,} from "src/domain/model/app_notification_message";
import {FrontDate} from "src/domain/model/frontDate";
import Assets from "src/presentation/assets/img/assets";
import BtnCorporateMiddle from "src/presentation/common/atom/btn/btn_corporate_middle";
import AppNotificationWithTexts from "src/presentation/common/organism/app_notification_with_texts";
import {routeConfig} from "../../config/language/ja-JP/presentation/route_text";
import {createApiClient, IApiClient} from "../../infra/api/client";
import PageWrapper from "../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../common/molecular/breadcrumbs/breadcrumbs";
import {TBreadcrumbItem} from "../type/common";
import Faq from "../component/faq";

const apiClient: IApiClient = createApiClient();

interface IProps extends RouteComponentProps<{}> {
}

const CustomerProjectSharing: React.FC<IProps> = (props) => {
    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        {text: `案件シェアリング`},
    ];
    const [messages, setMessages] = React.useState<AppNotificationMessage[]>([]);

    React.useEffect(() => {
        const searchParams = new URLSearchParams(props.location.search);
        const successParam = searchParams.get("success");
        if (successParam === "true") {
            setMessages([
                AppNotificationMessage.from(
                    "",
                    AppNotificationType.INFO,
                    "案件シェアリングの申し込みが完了しました",
                    FrontDate.fromEmpty()
                ),
            ]);
        }
    }, []);

    return (
        <React.Fragment>
            {messages.length > 0 && (
                <AppNotificationWithTexts
                    onClose={(id: string) =>
                        (event: any): void => {
                            setMessages([]);
                        }}
                    appNotificationMessages={messages}
                />
            )}
            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems}/>

                <Faq title={"案件シェアリングの使い方"}
                     text={"案件シェアリングは、エキスパートが受け取った案件をLiberaに紹介すると15万円の報酬が得られるサービスです。案件情報を送信後、Libera担当者が確認・フォローし、成約時に報酬が支払われます。"}
                     link={
                         "https://branch-saturn-9ef.notion.site/178b91fe393e80b08290d69293b3baf0"
                     }/>

                <div>
                    <img
                        src={Assets.sharingPage}
                        alt="案件シェアリング"
                        style={{width: 900, display: "block", margin: "0 auto"}}
                    />
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <BtnCorporateMiddle
                            onClick={() => {
                                props.history.push("/customer/project-sharing/form");
                            }}
                        >
                            案件の紹介を行う
                        </BtnCorporateMiddle>
                    </div>
                </div>
            </PageWrapper>
        </React.Fragment>
    );
};

export default CustomerProjectSharing;



// WEBPACK FOOTER //
// ./src/presentation/container/customer_project_sharing.tsx